<template>
    <div>
        <div class="hotline">
            <div></div>
            <img :src="require('@/assets/img/phone.png')" >
        </div> 
    </div>
</template>
<script>
export default {
    data(){ 
        return{ 

        }
    }
}
</script>
<style scoped lang='scss'>

.hotline{
    width: 1050px;
    font-size: 16px;
    text-align: left;
    margin-left: 100px;
    margin-top: 60px;
    padding-bottom: 40px;
    font-family: SourceHanSansCN-Regular;
        p{
            width: 100%;
            padding-bottom: 10px;
        }
        ul li{
            list-style: none;
        }
        img{
            width: 52px;
            height: 52px;
            position: absolute;
            left: 3%;
            top: 117px;
        }
    
}
</style>
